import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { StyledButton } from '../styled-button/styled-button';
import { Typography } from '@mui/material';

export const DialogContentOptions = () => {
  const { t } = useTranslation();
  return (
    <>
      <Typography>{t('leave_confirm_prompt_msg_1')}</Typography>
      <Typography>{t('leave_confirm_prompt_msg_2')}</Typography>
    </>
  );
};

export const DialogTitleOptions = () => {
  const { t } = useTranslation();
  return (
    <>
      {t('leave_confirm_prompt_title')}
    </>
  );
};

type IConfirmProps = {
  onConfirm?: () => void;
}

export const ConfirmationTextOptions = (props: IConfirmProps) => {
  const { t } = useTranslation();
  return (
    <StyledButton style={{ textTransform: "none" }} onClick={props.onConfirm ? props.onConfirm : undefined}>
      {t('common_leave')}
    </StyledButton>
  );
};

type ICancelProps = {
  onCancell?: () => void;
}

export const CancellTextOptions = (props: ICancelProps) => {
  const { t } = useTranslation();
  return (
    <StyledButton style={{ textTransform: "none" }} 
      className="MuiButton-containedSecondary"
      onClick={props.onCancell ? props.onCancell : undefined}
    >
      {t('common_cancel')}
    </StyledButton>
  );
};

const renderDialogTitleOptions = (onClose : () => void ) => {
  return (
    <>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[600],
        }}
      >
        <CloseIcon />
      </IconButton>
  </>
  );
}

export const dialogOptions = {
  title: <DialogTitleOptions />,
  description: <DialogContentOptions />,
  confirmationText: <ConfirmationTextOptions />,
  cancellationText: <CancellTextOptions />,
};

